<div style="max-width: 450px; text-align: center;" class="m-x-auto w-auto-xs p-y-md">
  <div class="p-a-md box-color r box-shadow-z1 text-color m-a">
    <div class="login-logo"></div>

    <ng-container *ngIf="type === 'browser'">
      <div class="alert alert-danger m-t-sm" role="alert">
        {{ 'COMMON.browser_not_supported' | translate }}
      </div>
    </ng-container>

    <ng-container *ngIf="type === 'device'">
      <div class="alert alert-danger m-t-sm" role="alert">
        {{ 'COMMON.device_not_supported' | translate }}
      </div>
    </ng-container>
  </div>
</div>
